<div class="container" *transloco="let t">
  <app-fancy-button [disabled]="images.length === maxNoOfImages" *ngIf="!readonly" class="button"
                    [type]="ButtonType.Default"
                    [icon]="'plus.svg'"
                    [title]="t('AUDIT-PAGE.IMAGE-VIEW.ADD-PHOTO')"
                    [text]="images.length +'/'+ maxNoOfImages" (click)="addImage()"></app-fancy-button>
  <div class="image-box" *ngFor="let image of images; index as i" (click)="openGallery(i)">
    <img src={{image.data}}>
  </div>
  <app-popup [(isOpen)]="popupVisible" [readonly]="readonly" [withBlur]="withBlur" [dynamicComponent]="dynamicComponent"
             [data]="images" [from]="slideInFrom"></app-popup>
  <div *ngIf="showErrorMessage && images.length === maxNoOfImages" class="error">
    <p>{{ t('AUDIT-PAGE.IMAGE-VIEW.LIMIT-ERROR', { limit: maxNoOfImages }) }}</p>
  </div>
</div>
